<template>
  <vx-card class="campaign-summary" :noShadow="true">
    <div class="mb-10" v-for="(adset, index) in data.adsets" :key="'adset-ads-summary-' + index">
      <div class="vs-row header-divider">
        <vs-divider v-if="index == 0" />

        <p class="font-bold mb-3 custom-type-style">
          {{ $t('Ad Set Name') }}:
        </p>
        <p class="mb-3 custom-type-style">
          {{ adset.name }}
        </p>
      </div>

      <vs-divider class="custom-divider-style" />

      <div class="vs-row">
        <p class="font-bold mb-3 custom-type-style">
          {{ $t('Ads') }}:
        </p>
        <p v-for="(ad, adIndex) in adset.ads" :key="'summary-ad-' + adIndex" class="custom-type-style">
          {{ ad.name }}
        </p>
      </div>

      <vs-divider v-if="index + 1 != data.adsets.length" class="custom-divider-style" />
    </div>
  </vx-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
